import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import classNames from 'classnames';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import  {postData, getData } from '../ApiCalls/DataApis';
import { connect} from "react-redux";
import {showSuccessSnackbar, showErrorSnackbar} from '../store/actions/snackbarActions';
import IconButton from '@material-ui/core/IconButton';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PasswordInfoModalOrgApis from '../components/PasswordInfoModalOrgApis';
import Tooltip from '@material-ui/core/Tooltip';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';


const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#757575",
    color: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    fontSize: 12,
    border: '1px solid #fafafa',
  },
  arrow: {
    color: '#757575',
  },
}))(Tooltip);

const styles = theme => ({
  paper: {
    position: 'relative',
    width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0),
    borderRadius: '10px',
    [theme.breakpoints.down('sm')]:{
      width: theme.spacing(43),
    }
  },
  button: {
    backgroundColor:'transparent',
    borderRadius:'24px',
    border:'1px solid #4f86ce',
    display:'inline-block',
    cursor:'pointer',
    color:'#4f87cc',
    minWidth: '180px',
    fontFamily:'Trebuchet MS',
    fontSize:'12px',
    // font-weight:bold;
    padding:'3px 10px',
    textDecoration:'none',
    textShadow:'0px 0px 0px #9eb9ff',
    outline: 'none',
    '&:hover': {
      backgroundColor:'transparent',
    },
    '&:active': {
      position:'relative',
      top:'1px',
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  buttonSuccess: {
    backgroundColor: green[500],
    color: '#fafafa',
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  dialog: { borderRadius: 10 } ,
  hoverText: {    
    fontSize: 33,
    paddingLeft: 0,
  },
  radioLabel: {
    fontSize: 14,
  },
  radioCSS: {
    // border: "1px solid blue",
    fontSize: 'small'
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class CreateIoTApiKeyModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      loading: false,
      success: false,
      iotApiKeyName: '',
      iotApiKeyDescription: '',
      iotApiKeyAuthorizaton: '',
      passwordInfoModalOpen: false,
      generated_client_id:'',
      generated_password: '',
      clientName: '',
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.submitButtonClick = this.submitButtonClick.bind(this);
    this.handleClosePasswordModal = this.handleClosePasswordModal.bind(this);
  }



  handleOpen = () => {
    this.setState({ 
      open: true,
      loading: false,
      success: false,
      iotApiKeyName: '',
      iotApiKeyDescription: '',
      passwordInfoModalOpen: false,
      generated_client_id:'',
      generated_password: ''
    });
  };

  handleClose = () => {
    this.setState({ 
      open: false,
      loading: false,
      success: false,
      iotApiKeyName: '',
      iotApiKeyDescription: '',
    });
  };

  handleIoTApiKeyNameChange = (event) => {
    this.setState({iotApiKeyName: event.target.value});
  }

  handleIoTApiKeyDescriptionChange = (event) => {
    this.setState({iotApiKeyDescription: event.target.value});
  }

  handleClosePasswordModal = () => {
    this.setState({passwordInfoModalOpen: false});
  }

  submitButtonClick = () => {
    const { loading } = this.state;
    if (!loading) {
      this.setState(
        {
          success: false,
          loading: true,
          passwordInfoModalOpen: false,
        },
        () => {
        postData('https://api.iotflows.com/v1/organizations/' + this.props.selectedOrganization.organization_uuid +'/clients', 
        {'client_name': this.state.iotApiKeyName,
          'client_description': this.state.iotApiKeyDescription,
          'only_allow_subscription': this.state.iotApiKeyAuthorizaton})
          .then(async response => {
            if(response.ok){
              const data = await response.json();
              this.props.showSuccessSnackbar("IoT API Key has been successfully added!");
              this.props.refreshClientList();
              this.setState({
                loading: false,
                success: true,
                open:false,
                passwordInfoModalOpen: true,
                generated_client_id: data.data[0].client_username,
                generated_password: data.data[0].client_password,
                clientName: this.state.iotApiKeyName,
              }, ()=> {this.handleClose()});
            }
            else{
              try{
                const data = await response.json();
                this.props.showErrorSnackbar(data.message);
                this.setState({
                  loading: false,
                  success: false,
                  open:false,
                  passwordInfoModalOpen: false,
                  clientName: '',
                }, ()=> {this.handleClose()});
              }catch (e){
                this.props.showErrorSnackbar('Something went wrong');
              }
            }
          })
        }
      )
    }
  };

  handleIoTApiKeyAuthorizatonChange = (event) => {
    this.setState({iotApiKeyAuthorizaton: event.target.value});
  };


  render() {
    const { classes } = this.props;
    const { open, 
            loading, 
            success, 
            passwordInfoModalOpen, 
            generated_client_id, 
            generated_password, 
            iotApiKeyAuthorizaton,
            iotApiKeyName,
            iotApiKeyDescription,
            clientName} = this.state;

    const buttonClassname = classNames({
      [classes.buttonSuccess]: success,
    });
    

    return (
      <Grid
        container
        alignItems="flex-end"
        justify="flex-end"
        direction="column"
      >
        
        <Button className={classes.button} variant="contained"   onClick={this.handleOpen}><AddCircleOutlineOutlinedIcon />&nbsp;Create IoT API Key </Button>
        {passwordInfoModalOpen && 
          <PasswordInfoModalOrgApis open={passwordInfoModalOpen} handleClosePasswordModal={this.handleClosePasswordModal} generated_client_id={generated_client_id} generated_password={generated_password} clientName={clientName} /> 
          }

          <Dialog
              open={open}
              onClose={this.handleClose}
              TransitionComponent={Transition}
              keepMounted
              classes = {{paper: classes.dialog}}
            >
              <Paper className={classes.paper} >
                <DialogTitle style={{paddingBottom: '0px'}} id="alert-dialog-slide-title">{"Create IoT API Key"}</DialogTitle>
                <DialogContent dividers style={{paddingBottom: '20px', paddingTop: '0px'}}>
                <TextField
                  autoFocus
                  margin="normal"
                  id="iotApiKeyName"
                  label="Name"
                  type="text"
                  value={iotApiKeyName} 
                  onChange={this.handleIoTApiKeyNameChange}
                  fullWidth
                />

                <TextField
                  autoFocus
                  margin="normal"
                  id="iotApiKeyDescription"
                  label="Description"
                  type="text"
                  value={iotApiKeyDescription} 
                  onChange={this.handleIoTApiKeyDescriptionChange}
                  fullWidth
                />

                <FormControl  stle={{margin: '10px'}} component="fieldset">
                  {/* <FormLabel component="legend">Authorization</FormLabel> */}
                  <RadioGroup style={{margin: '10px'}} aria-label="role" name="IoTApiKeyAutorization"   value={iotApiKeyAuthorizaton} onChange={this.handleIoTApiKeyAuthorizatonChange}>
                      <LightTooltip className={classes.hoverText} title={'IoT API Key can only subscribe to topics'} placement="right-start" arrow  >
                        <FormControlLabel classes={{label: classes.radioLabel}} value={'true'} control={<Radio color="primary"  className={classes.radioCSS}/>} label={'Read Only'} />
                      </LightTooltip>
                      <LightTooltip className={classes.hoverText} title={'IoT API Key can subscribe and publish to topics'} placement="right-start" arrow  >
                        <FormControlLabel classes={{label: classes.radioLabel}} value={'false'} control={<Radio color="primary"  className={classes.radioCSS}/>} label={'Read/Write Access'} />
                      </LightTooltip>
                  </RadioGroup>
                </FormControl>

                </DialogContent>
                <DialogActions style={{justifyContent:'flex-end'}}>
                  <Button onClick={this.handleClose} >
                    Close
                  </Button>
                  <Button  color="primary" type='submit' className={buttonClassname} disabled={loading} onClick={this.submitButtonClick}>
                    Submit { loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </Button>
                </DialogActions>
              </Paper>
         
        </Dialog>
        
      </Grid>
    );
  }
}

CreateIoTApiKeyModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => ({
  showSuccessSnackbar: message => dispatch(showSuccessSnackbar(message)),
  showErrorSnackbar: message => dispatch(showErrorSnackbar(message)),

})
const mapStateToProps = state => {
  return {
    selectedOrganization: state.organizations.selectedOrganization,

  }
}

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(CreateIoTApiKeyModal));
